<template>
  <div class="container">
    <div class="header-left">
      <img src="@/assets/logo.svg" alt="Clue" class="logo">
      <div class="info">
        <span class="project-title"><slot name="title"></slot></span>
        <span class="client"><slot name="client"></slot></span>
      </div>
    </div>
    <div class="header-center">
      <div class="current-slide slide-thumbs-toggle" @click="toggleThumbnails"><span class="title"><slot>Concept</slot></span></div>
    </div>
    <div class="header-right">
      <button class="btn btn-hollow toggle-btn toggle-mode" @click="toggleDarkMode"><span></span></button>
      <button class="btn btn-hollow toggle-btn toggle-fullscreen" @click="toggleFullScreen"><span></span></button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HeaderDetail',
  
  components: {},

  props: {},

  methods: {
    toggleThumbnails() {
      $('#concepts-detail').toggleClass('show-thumbnails');
    },
    toggleDarkMode() {
      $('#concepts-detail').toggleClass('darkmode');
      this.$store.dispatch("toggleDarkMode");
    },
    toggleFullScreen() {
      $('#concepts-detail').toggleClass('fullscreen');
    },    
  },
  
  mounted() {
    if (this.$store.state.darkMode) {
      $('#concepts-detail').addClass('darkmode');
    }
  }

}
</script>